import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import WalletConnect from './WalletConnect';
import { Offcanvas } from 'react-bootstrap';
import SidebarUser from '../Components/SidebarUser';
import { UserContext } from '../Context/UserContext';
import { FaSignOutAlt } from 'react-icons/fa';
import ThemeToggle from './ThemeToggle';
import LanguageToggle from './LanguageToggle';
import { useTranslation } from '../Context/LanguageContext';

const Header = (props) => {
  const { logoutHandle } = props;
  const [show, setShow] = useState(false);
  const { user } = useContext(UserContext);
  const { name, role } = user?.user || {};
  const { t } = useTranslation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <nav
        className='dashboard-header navbar navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl'
        id='navbarBlur'
        navbar-scroll='true'
      >
        <div className='container-fluid py-1 px-3'>
          <nav aria-label='breadcrumb'>
            <ol className='breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5'>
              <li className='breadcrumb-item text-sm'>
                <Link className='opacity-5' style={{ color: 'var(--text-muted)' }} to='/dashboard'>
                  {t('pages')}
                </Link>
              </li>
              <li
                className='breadcrumb-item text-sm active'
                style={{ color: 'var(--text-primary)' }}
                aria-current='page'
              >
                {t('dashboard')}
              </li>
            </ol>
            <h6 className='font-weight-bolder mb-0' style={{ color: 'var(--text-primary)' }}>{t('dashboard')}</h6>
          </nav>

          <div
            className='collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4'
            id='navbar'
          >
            <div className='ms-md-auto pe-md-3 d-flex align-items-center'>
              {/* Input placeholder if needed */}
            </div>
            <ul className='navbar-nav  justify-content-end'>
              <li className='nav-item d-flex align-items-center me-2'>
                <LanguageToggle />
              </li>
              <li className='nav-item d-flex align-items-center me-2'>
                <ThemeToggle />
              </li>
              <li className='nav-item d-flex align-items-center'>
                <WalletConnect />
              </li>

              <li className='nav-item px-3 d-flex align-items-center'>
                <div className='user-profile-pill no-arrow cursor-default'>
                  <div className='user-info d-flex flex-column'>
                    <span className='user-name'>
                      {name ? name.split(' ')[0] : 'User'}
                    </span>
                    <span className='user-role'>{role || 'Member'}</span>
                  </div>
                </div>
              </li>
              <li className='nav-item d-flex align-items-center'>
                <button
                  onClick={logoutHandle}
                  className='btn btn-link p-0 m-0'
                  style={{ color: 'var(--text-primary)' }}
                  title='Sign Out'
                >
                  <FaSignOutAlt size={20} />
                </button>
              </li>

              <li className='nav-item d-xl-none ps-3 d-flex align-items-center'>
                <a
                  href='javascript:;'
                  className='nav-link text-white p-0'
                  id='iconNavbarSidenav'
                  onClick={handleShow}
                >
                  <div className='sidenav-toggler-inner'>
                    <i className='sidenav-toggler-line bg-white'></i>
                    <i className='sidenav-toggler-line bg-white'></i>
                    <i className='sidenav-toggler-line bg-white'></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <Offcanvas show={show} onHide={handleClose} className='mobilesidebar'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className='d-flex align-items-center'>
              <div className='text-capitalize'>
                <i className='fa fa-user me-sm-1 me-2'></i>{' '}
                {name ? name.split(' ')[0] : ''} {`( ${role} )`}
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SidebarUser logoutHandle={logoutHandle} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
